export default "__VITE_ASSET__DmR$$XB$__"